import { Component, effect, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton, TuiDataList, TuiIcon, TuiTextfield } from '@taiga-ui/core';
import { TuiComboBoxModule, TuiInputModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy';
import { TuiDataListWrapper } from '@taiga-ui/kit';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DEFAULT_APP_ICON, ICON_TAGS, IconTag } from '@ffx/common';
import { ProjectStore } from '@ffx/app-store';

@Component({
    selector: 'ffx-icon-dropdown-search',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TuiButton,
        TuiComboBoxModule,
        TuiDataList,
        TuiDataListWrapper,
        TuiIcon,
        TuiInputModule,
        TuiTextfieldControllerModule,
        TuiTextfield
    ],
    templateUrl: './icon-dropdown-search.component.html',
    styleUrl: './icon-dropdown-search.component.scss'
})
export class IconDropdownSearchComponent {
    @Output() iconSelected = new EventEmitter<string>();
    @Input() placeholderText = '';
    @Input() originalIcon$ = signal(DEFAULT_APP_ICON);
    @Input() isEditProject = false;
    @Input() editIcon$ = signal(false);
    @Input() loadIcon$ = signal(false);

    private builder = inject(FormBuilder);
    private projectStore = inject(ProjectStore);
    protected search: string | null = '';

    filteredIcons: string[] = [];
    selectedIcon = '';
    iconForm = this.builder.nonNullable.group({
        iconControl: ['', []]
    });

    get iconControls(): any {
        return this.iconForm.controls;
    }

    constructor() {
        effect(() => {
            if (this.isEditProject && !this.projectStore.projectSettingsLoading() && this.loadIcon$()) {
                this.selectedIcon = this.originalIcon$();
                this.iconForm.patchValue({
                    iconControl: this.selectedIcon
                });
                this.iconForm.disable();
                this.filteredIcons = [];
            }

            if (this.editIcon$()) {
                this.iconForm.enable();
                this.filteredIcons = [];
            }
        });
    }

    protected filterIcons(): readonly string[] {
        const search = this.iconControls.iconControl.value;
        if (search) {
            const lowerCaseQuery = search.toLowerCase();
            const matchingIcons = ICON_TAGS.filter((icon: IconTag) => {
                return (
                    icon.name.toLowerCase().includes(lowerCaseQuery) ||
                    icon.tags.some((tag: string) => tag.toLowerCase().includes(lowerCaseQuery))
                );
            }).map((icon) => icon.name);
            this.filteredIcons = matchingIcons;
            return matchingIcons;
        }
        return [];
    }

    selectIcon(icon: string): void {
        this.iconSelected.emit(icon);
        this.selectedIcon = icon;
        this.iconForm.controls.iconControl.setValue(icon);
        this.filteredIcons = [];
    }

    public clearSearch(): void {
        this.iconForm.controls.iconControl.setValue('');
        this.selectedIcon = '';
    }
}
